import React from 'react';
import PropTypes from 'prop-types';
import PlayerSelectCheckbox from '../../Component/PlayerSelectCheckbox/PlayerSelectCheckbox';

const TableBody = (props) => {
  const {
    currentSort,
    sortedPlayersByUserId,
    sortedPlayers,
    sortedPlayersByRosterId,
    filteredUsers,
    selectedPlayers,
    handlePlayerJoin
  } = props;

  // Determine the sorted players based on the current sort
  const getSortedPlayers = () => {
    switch (currentSort) {
      case 'user':
        return sortedPlayersByUserId;
      case 'jersey':
        return sortedPlayers;
      case 'roster':
        return sortedPlayersByRosterId;
      default:
        return filteredUsers;
    }
  };

  const playersToDisplay = getSortedPlayers();

  return (
    <>
      {playersToDisplay?.map((player) => (
        <div className="flex justify-center items-center w-[944px]" key={player.roster_id}>
          <div className="max-w-[110px] min-w-[110px] w-full h-[56px] bg-transparent border-r-0 border-[1px] border-[#E8E8E8] text-black font-montserrat font-medium text-base flex justify-center items-center px-1 py-3">
            {player.roster_id ? player.roster_id : "auto"}
          </div>
          <div className="max-w-[120px] min-w-[120px] w-full h-[56px] bg-transparent border-[1px] border-[#E8E8E8] bg-white font-montserrat font-medium text-base flex justify-center items-center px-4 py-3">
            {player?.jersey_number}
          </div>
          <div className="max-w-[110px] min-w-[110px] w-full h-[56px] bg-transparent border-[1px] border-[#E8E8E8] bg-white font-montserrat font-medium text-base flex justify-center items-center px-4 py-3">
            <PlayerSelectCheckbox
              svgClass={`max-w-6 w-full min-w-6 h-6`}
              mainClass={`max-w-[165px] w-full rounded h-10 gap-3 justify-center items-center px-[6px] py-2`}
              text={``}
              svgContainerClass={`flex justify-center items-center w-full`}
              textClass={`font-montserrat font-medium text-base flex-1 text-nowrap block`}
              selectedPlayers={selectedPlayers}
              defaultValue={player?.is_present}
              customChecked={selectedPlayers.some(p => p.r_id === player.roster_id && p.present)}
              onChange={() => handlePlayerJoin(player)}
            />
          </div>
          <div className="max-w-[240px] min-w-[240px] w-full h-[56px] border-l-0 bg-transparent border-[1px] border-[#E8E8E8] text-black font-montserrat font-medium text-base flex justify-between px-4 py-3 items-center">
            {player.user_id}
          </div>
          <div className="max-w-[132.94px] min-w-[132.94px] w-full h-[56px] bg-transparent border-l-0 border-r-0 border-[1px] border-[#E8E8E8] text-black font-montserrat font-medium text-base flex justify-center items-center px-4 py-3">
            {player.short_name ? player.short_name : ""}
          </div>
          <div className="max-w-[132.94px] min-w-[132.94px] w-full h-[56px] bg-transparent border-[1px] border-[#E8E8E8] text-black font-montserrat font-medium text-base flex justify-center items-center px-4 py-3">
            {player.username ? player.username : ""}
          </div>
          <div className="max-w-[80px] min-w-[80px] w-full h-[56px] bg-transparent border-[1px] border-[#E8E8E8] text-black font-montserrat font-medium text-base flex justify-center items-center px-4 py-3">
            {player.mainposition ? player.mainposition : "N/A"}
          </div>
        </div>
      ))}
    </>
  );
};

TableBody.propTypes = {
  currentSort: PropTypes.string.isRequired,
  sortedPlayersByUserId: PropTypes.array.isRequired,
  sortedPlayers: PropTypes.array.isRequired,
  sortedPlayersByRosterId: PropTypes.array.isRequired,
  filteredUsers: PropTypes.array.isRequired,
  selectedPlayers: PropTypes.array.isRequired,
  handlePlayerJoin: PropTypes.func.isRequired,
};

export default TableBody;